module.exports = __webpack_public_path__ + "static/media/sleeverMartThumbnail.4c56286a.png";